
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { StepProps } from './types';

const MovementDetailsStep: React.FC<StepProps> = ({ data, onDataChange, onNext, onPrevious, errors }) => {
  const handleNext = () => {
    const newErrors: Record<string, string> = {};
    
    if (!data.occupation.trim()) newErrors.occupation = 'Occupation is required';
    
    if (Object.keys(newErrors).length === 0) {
      onNext();
    }
  };

  return (
    <Card className="w-full max-w-2xl mx-auto">
      <CardHeader>
        <CardTitle className="text-center text-2xl font-bold text-gray-900">
          Movement Details
        </CardTitle>
        <p className="text-center text-gray-600">Step 3 of 4</p>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <Label htmlFor="occupation">Occupation *</Label>
          <Input
            id="occupation"
            type="text"
            value={data.occupation}
            onChange={(e) => onDataChange({ occupation: e.target.value })}
            placeholder="Enter your occupation"
            className={errors.occupation ? 'border-red-500' : ''}
          />
          {errors.occupation && <p className="text-red-500 text-sm mt-1">{errors.occupation}</p>}
        </div>

        <div>
          <Label htmlFor="association">Association (Optional)</Label>
          <Input
            id="association"
            type="text"
            value={data.association || ''}
            onChange={(e) => onDataChange({ association: e.target.value })}
            placeholder="Enter your association or organization"
          />
        </div>

        <div>
          <Label htmlFor="referralCode">Referral Code (Optional)</Label>
          <Input
            id="referralCode"
            type="text"
            value={data.referralCode || ''}
            onChange={(e) => onDataChange({ referralCode: e.target.value })}
            placeholder="Enter referral code if you have one"
          />
        </div>

        <div className="flex gap-4 mt-6">
          <Button onClick={onPrevious} variant="outline" className="flex-1">
            Previous
          </Button>
          <Button onClick={handleNext} className="flex-1">
            Next: Review
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default MovementDetailsStep;
